
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#B6B6B6","d":"M15.918 15.387L14.762 11.9h-1.268l.704 3.4H1.802l.704-3.4H1.238L.082 15.387C-.211 16.274.308 17 1.238 17h13.524c.93 0 1.45-.726 1.156-1.613zM12.227 4.25C12.226 1.903 10.335 0 8 0 5.666 0 3.774 1.903 3.774 4.25c0 4.059 4.226 8.5 4.226 8.5s4.226-4.441 4.226-8.5zm-6.509.051A2.288 2.288 0 018 2.007 2.288 2.288 0 0110.282 4.3 2.288 2.288 0 018 6.596a2.289 2.289 0 01-2.282-2.295z"}})])
          )
        }
      }
    